import VDMDashboardConsumption from "components/app/vdmdashboard/consumption/VDMDashboardConsumption";
import React from "react";

type ScreenVDMDashboardConsumptionType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardConsumption: React.FC<
	ScreenVDMDashboardConsumptionType
> = (props: ScreenVDMDashboardConsumptionType) => {
	return <VDMDashboardConsumption vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardConsumption;
